module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "fmtitle"
  }, [_vm._v("TABLE OF CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "fmimagea"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/ch1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "tocfm"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/fm02"
    }
  }, [_vm._v("INTRODUCTION: WHO WOULD I BE TODAY?")])]), _vm._v(" "), _c('p', {
    staticClass: "tocpart"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/part01"
    }
  }, [_vm._v("PART 1: BEING A FIREWORK HUMAN")])]), _vm._v(" "), _c('p', {
    staticClass: "tocch"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chap01"
    }
  }, [_c('span', {
    staticClass: "tocspace"
  }, [_vm._v("CHAPTER 1:")]), _vm._v("We’re All Fundamentally Entrepreneurial")])]), _vm._v(" "), _c('p', {
    staticClass: "tocch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocspace"
  }, [_vm._v("CHAPTER 2:")]), _vm._v("Sparking the Flame of the Growth Mindset")])]), _vm._v(" "), _c('p', {
    staticClass: "tocch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocspace"
  }, [_vm._v("CHAPTER 3:")]), _vm._v("The Power of Language")])]), _vm._v(" "), _c('p', {
    staticClass: "tocch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocspace"
  }, [_vm._v("CHAPTER 4:")]), _vm._v("Supporting a Growth Mindset")])]), _vm._v(" "), _c('p', {
    staticClass: "tocch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocspace"
  }, [_vm._v("CHAPTER 5:")]), _vm._v("Does Childhood Matter?")])]), _vm._v(" "), _c('p', {
    staticClass: "tocch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap06",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocspace"
  }, [_vm._v("CHAPTER 6:")]), _vm._v("The 9 Entrepreneurial Instincts")])]), _vm._v(" "), _c('p', {
    staticClass: "tocpart"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART 2 – THE 9 ENTREPRENEURIAL INSTINCTS")])]), _vm._v(" "), _c('p', {
    staticClass: "tocch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap07",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocspace"
  }, [_vm._v("CHAPTER 7:")]), _vm._v("How to Nurture the Knowledge-Seeking Instinct")])]), _vm._v(" "), _c('p', {
    staticClass: "tocch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap08",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocspace"
  }, [_vm._v("CHAPTER 8:")]), _vm._v("How to Nurture the Audacious Dreamer Instinct")])]), _vm._v(" "), _c('p', {
    staticClass: "tocch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap09",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocspace"
  }, [_vm._v("CHAPTER 9:")]), _vm._v("How to Nurture the Try-Again Instinct")])]), _vm._v(" "), _c('p', {
    staticClass: "tocch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocspace1"
  }, [_vm._v("CHAPTER 10:")]), _vm._v("How to Nurture the Prove-It-To-Me Instinct")])]), _vm._v(" "), _c('p', {
    staticClass: "tocch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocspace1"
  }, [_vm._v("CHAPTER 11:")]), _vm._v("How to Nurture the I’ll-Fix-It Instinct")])]), _vm._v(" "), _c('p', {
    staticClass: "tocch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocspace1"
  }, [_vm._v("CHAPTER 12:")]), _vm._v("How to Nurture the Evolving Instinct")])]), _vm._v(" "), _c('p', {
    staticClass: "tocch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocspace1"
  }, [_vm._v("CHAPTER 13:")]), _vm._v("How to Nurture the Whatever-It-Takes Instinct")])]), _vm._v(" "), _c('p', {
    staticClass: "tocch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocspace1"
  }, [_vm._v("CHAPTER 14:")]), _vm._v("How to Nurture the Go-Out-On-A-Ledge Instinct")])]), _vm._v(" "), _c('p', {
    staticClass: "tocch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap15",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocspace1"
  }, [_vm._v("CHAPTER 15:")]), _vm._v("How to Nurture the Connections Instinct")])]), _vm._v(" "), _c('p', {
    staticClass: "tocch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap16",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocspace1"
  }, [_vm._v("CHAPTER 16:")]), _vm._v("Examples of Firework Humans – The Famous, Young, and Impactful")])]), _vm._v(" "), _c('p', {
    staticClass: "tocch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap17",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocspace1"
  }, [_vm._v("CHAPTER 17:")]), _vm._v("Understanding Learning Styles")])]), _vm._v(" "), _c('p', {
    staticClass: "tocch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap18",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocspace1"
  }, [_vm._v("CHAPTER 18:")]), _vm._v("Conclusion – My Vision for the Future")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbmt"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bm01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ACKNOWLEDGMENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbm"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bm02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ABOUT THE AUTHOR")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbm"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bm03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ENDNOTES")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9ee5fb14","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/toc.vue
// module id = 72
// module chunks = 0